export default "__VITE_ASSET__Rqp_ZxoE__"